<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header">
        <span class="hris-page-eyebrow">Employee Reports</span>
        <h1 class="hris-page-title">Trainee Employee Report</h1>
        <p class="hris-page-subtitle">Generate and export pantry purchase reports for trainees.</p>
      </div>

      <q-form @submit="filterReport" class="hris-toolbar">
        <div class="hris-form-field" style="flex: 0 1 180px;">
          <q-input outlined dense color="green" v-model="fromDate" mask="date" :rules="['date']" label="Date From">
            <template v-slot:append>
              <q-icon name="far fa-calendar-alt" class="cursor-pointer">
                <q-popup-proxy ref="fromDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="fromDate" @input="() => $refs.fromDateProxy.hide()"></q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="hris-form-field" style="flex: 0 1 180px;">
          <q-input outlined dense color="green" v-model="toDate" mask="date" :rules="['date']" label="Date To">
            <template v-slot:append>
              <q-icon name="far fa-calendar-alt" class="cursor-pointer">
                <q-popup-proxy ref="dhDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="toDate" @input="() => $refs.dhDateProxy.hide()"></q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="hris-form-field" style="flex: 0 1 220px;">
          <q-select outlined dense color="green" v-model="store" :options="storeOptions" label="Store Name" emit-value map-options option-value="id" option-label="name" :rules="[formRules.required]"></q-select>
        </div>
        <q-btn unelevated class="hris-q-primary" label="Generate Report" type="submit"></q-btn>
      </q-form>

      <div class="hris-panel">
        <q-table flat :data="traineeEmployee" :columns="columns" row-key="name" :loading="loading">
          <template v-slot:body="props">
            <q-tr slot="body" :props="props">
              <q-td key="transaction_number" :props="props">{{ props.row.transaction_number }}</q-td>
              <q-td key="employee_name" :props="props">{{ props.row.employee_name }}</q-td>
              <q-td key="storename" :props="props">{{ props.row.storename }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
              <q-td key="total_price" :props="props">{{ props.row.total_price }}</q-td>

              <q-td key="action" :props="props">
                <q-btn outline dense class="hris-q-outline" size="sm" icon="fas fa-calendar" label="View" @click="viewDetail(props.row)"></q-btn>
              </q-td>
            </q-tr>
          </template>
          <template v-slot:loading>
            <q-inner-loading showing>
              <div class="hris-loading">
                <q-spinner color="green" size="40px"></q-spinner>
                <span>Loading report...</span>
              </div>
            </q-inner-loading>
          </template>
          <template v-slot:no-data>
            <div class="hris-empty full-width">No result found.</div>
          </template>
          <template v-slot:top-right>
            <q-btn
              v-show="traineeEmployee.length > 0"
              unelevated
              class="hris-q-primary"
              label="Download Computed CSV"
              no-caps
              @click="exportTable"
            ></q-btn>
          </template>
        </q-table>
      </div>

      <q-dialog v-model="detailsDialog" persistent>
        <div class="hris-modal">
          <div class="hris-modal-header">
            <div>
              <h2 class="hris-modal-title">Order Details</h2>
              <p class="hris-modal-subtitle">{{ details.employee_name }} &middot; {{ details.department }}</p>
            </div>
          </div>
          <div class="hris-modal-body">
            <div class="hris-section-label">{{ details.transaction_number }}</div>
            <p class="hris-form-section-hint" style="margin-top: -6px;">{{ details.date_created_formatted }}</p>
            <q-markup-table flat>
              <thead>
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-right">Qty</th>
                  <th class="text-right">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in details.products" :key="item.id">
                  <td class="text-left">{{ item.product_name }}</td>
                  <td class="text-right">{{ item.quantity }}</td>
                  <td class="text-right">₱ {{ item.price }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="text-left">Total Price</th>
                  <th class="text-right"></th>
                  <th class="text-right">₱ {{ details.total_price }}</th>
                </tr>
              </tfoot>
            </q-markup-table>
          </div>
          <div class="hris-modal-footer">
            <q-btn unelevated class="hris-q-outline" label="Close" v-close-popup></q-btn>
          </div>
        </div>
      </q-dialog>
    </div>
  </div>
</template>
  <script>
  import axios from 'axios';
  export default {
    name: 'Pantry',
    data() {
      return {
         loading:false,
         detailsDialog: false,
         fromDate: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
         toDate: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
         store:'',
         storeOptions: [],

        pagination: {
          rowsPerPage: 10
        },

        columns: [
        { name: 'transaction_number', align: 'left', label: 'Transaction Number', field: 'transaction_number', sortable: true },
        { name: 'employee_name', align: 'center', label: 'Employee Name', field: 'employee_name', sortable: true },
        { name: 'storename', align: 'center', label: 'Store Name', field: 'storename', sortable: true },
        { name: 'department', align: 'center', label: 'Department', field: 'department', sortable: true },
        { name: 'total_price', align: 'center', label: 'Total Price', field: 'total_price', sortable: true },
        { name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
        ],
        traineeEmployee:[],
        details:{}
      }

    },

    created() {
        this.storeList()
    },

    methods: {
      filterReport(){
         this.loading = true
            var form = new FormData()
            form.append('fromDate',this.fromDate);
            form.append('toDate',this.toDate);
            form.append('store',this.store);
            axios.post(
              this.apiUrl+'/mobile/pantry/trainee/report',form,
              { headers : {'Authorization' : `Bearer ${this.token}`}}
            ).then((res)=>{
               this.traineeEmployee = res.data;
               this.loading = false
            })
        },

      exportTable () {
         var formData = new FormData()
         formData.append('fromDate',this.fromDate);
         formData.append('toDate',this.toDate);
         formData.append('store',this.store);

         axios.create({
          baseURL : this.apiUrl,
          responseType: 'arraybuffer',
          headers : {'Authorization' : `Bearer ${this.token}`}
       }).post(`/mobile/pantry/trainee/export`,formData)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Trainee_Employee_Report.xlsx');
          document.body.appendChild(fileLink);
          fileLink.click();
        });
      },

      storeList : function(){
        axios.create({
            baseURL : this.apiUrl,
            headers : {'Authorization' : `Bearer ${this.token}`}
        }).get(`/mobile/pantry/store/list`)
        .then((res) => {
            this.storeOptions = res.data
        });
      },

      viewDetail: function(obj){
         this.details = obj
         this.detailsDialog = true
      }

    }
  }
  </script>
